module.exports = __webpack_public_path__ + "img/islington_house_b1.4e0e59d9.jpg";